import { render, staticRenderFns } from "./ReserveSideBar.vue?vue&type=template&id=5a850052&scoped=true&"
import script from "./ReserveSideBar.vue?vue&type=script&lang=js&"
export * from "./ReserveSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a850052",
  null
  
)

export default component.exports